import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hiddenLoader } from "../stores/loading";
import { fetchAPI } from "../utils/api";
import { Form } from "./form/Form";
import { Table } from "./table/Table";

export default function Producer() {
    const dispatch = useDispatch();
    const [formState, setFormState] = useState({} as any);
    const [resultProducer, setResultProducer] = useState([] as any);
    const [operators, setOperators] = useState([] as any);
    const [producerStatus, setProducerStatus] = useState([] as any);
    const [page, setPage] = useState(0 as any);

    useEffect(() => {
        fetchAPI("/operators")
            .then((res) => res.json())
            .then(setOperators);
        fetchAPI("/producers/statuses")
            .then((res) => res.json())
            .then(setProducerStatus);
    }, []);

    function search(form: any, page: number = 0) {
        setFormState(form);
        setPage(page)
        fetchAPI(`/producers/search?page=${page}&size=15`, {
            method: "POST",
            body: JSON.stringify(form)
        })
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    return res.json()
                }
                dispatch(hiddenLoader());
                return res;
                
            })
            .then(setResultProducer);

    }

    function update(producer: any) {
        fetchAPI(`/producers/${producer.uid}/operators/${producer.operator}`, {
            method: "PATCH",
            body: JSON.stringify({status : producer.status})
        })
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    return res.json()
                }
                dispatch(hiddenLoader());
                return res;
                
            })
            .then(() => search(formState, page));
    }


    function reset() {
        setResultProducer([])
    }

    let form = {
        "start_date": "datetime",
        "thru_date": "datetime",
        "operators": {
            type: 'multiple', value: operators.length > 0 ? operators.map((v: any) => v.name) : []
        },
        "producer": "string",
        "status": {
            type: 'multiple', value: producerStatus ? producerStatus.map((v : any) => v.value) : []
        },
        "institutions": {
            type: 'multiple', value: ["LEMONWAY", "HYPERWALLET"]
        }
    }

    let headers = [
        "uid",
        "operator",
        "name",
        "status",
        "institution_name",
        "institution_account_id"
    ]

    let tooltips = {
        status : producerStatus
    }

    return (<>
        <div className="vtmn-p-4">
            <Form
                form={form}
                search={(form: any, page: number) => search(form)}
                reset={() => reset()}
            />
        </div>
        <div>
            {resultProducer?.content?.length > 0 &&
                <Table
                    update={true}
                    result={resultProducer}
                    headers={headers}
                    changePage={(page: number) => search(formState, page)}
                    tooltips={tooltips}
                    FormUpdate={(v: any) => FormUpdateProducer({...v, producerStatus, update})}
                />}
            {resultProducer.status === 404 && <p className="vtmn-text-center">No Result</p>}
        </div>
    </>
    )
}

export function FormUpdateProducer({fieldSelected, setFieldSelected, producerStatus, update} : any) {

    const [status, setStatus] = useState(fieldSelected.status as string);
 
    function functionUpdate(value: any) {
        update({...value, status});
        setFieldSelected(null);
    }

    return (<>
        <div className="vtmn-modal_content_body">
            <div className="vtmn-grid vtmn-grid-cols-1 vtmn-gap-0 vtmn-mb-2" >
                <div className="block">Uid : {fieldSelected.uid}</div>
                <div className="block">Operator : {fieldSelected.operator}</div>
                <div className="block">Name : {fieldSelected.name}</div>
                <div className="block">Status : 
                <select name="status" id="status-select" onChange={(e) => setStatus(e.target.value)}>
                    {producerStatus.sort().map((st: any) => {
                        return <option key={st.value} value={st.value} selected={fieldSelected.status === st.value}>{st.value}</option>
                    })}
                </select>
                </div>
                <div className="block">Institution_name : {fieldSelected.institution_name}</div>
                <div className="block">Institution_account_id : {fieldSelected.institution_account_id}</div>
            </div>
        </div>
        <div className="vtmn-modal_content_actions">
          <button className="vtmn-btn vtmn-btn_variant--secondary" onClick={() => setFieldSelected(null)}>Close</button>
          <button className="vtmn-btn vtmn-btn_variant--primary" onClick={() => functionUpdate(fieldSelected)}>
            Save
          </button>
        </div>
    </>
    )
}

